var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"w"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goback}},[_vm._v("返回")]),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }